export enum SettingType {
    JSON = 'JSON',
    URL = 'URL',
    STRING = 'STRING',
    EMAIL = 'EMAIL',
    MEDIAOBJECT_ID = 'MEDIAOBJECT_ID',
    PASSWORD = 'PASSWORD',
    MULTILINE = 'MULTILINE',
    BOOLEAN = 'BOOLEAN',
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    COLOR = 'COLOR',
    ENUM = 'ENUM',
    ARRAY = 'ARRAY',
    FIELD_DEFINITION_ARRAY = 'FIELD_DEFINITION_ARRAY',
    ENUM_ARRAY = 'ENUM_ARRAY'
}

export enum SettingComponentType {
    Boolean = 'Boolean',
    Number = 'Number',
    Password = 'Password',
    Tags = 'Tags',
    Text = 'Text',
    TextArea = 'TextArea',
    FieldDef = 'FieldDef'
}

export interface BaseSetting {
    Key: string;
    Category: string;
    Privilege: string;
    Label: string;
    Description: string;
    Writeable: boolean;
    Required: boolean;
}

export interface ApiSetting extends BaseSetting {
    Value: string;
    Type: SettingType;
}

export interface StringSetting extends BaseSetting {
    Value: string;
    Type:
        | SettingType.STRING
        | SettingType.URL
        | SettingType.COLOR
        | SettingType.EMAIL
        | SettingType.MULTILINE
        | SettingType.MEDIAOBJECT_ID
        | SettingType.PASSWORD;
}
export interface NumberSetting extends BaseSetting {
    Value: number;
    Type: SettingType.INTEGER | SettingType.FLOAT;
}
export interface BooleanSetting extends BaseSetting {
    Value: boolean;
    Type: SettingType.BOOLEAN;
}

export interface ArraySetting extends BaseSetting {
    Value: boolean;
    Type: SettingType.ARRAY | SettingType.ENUM_ARRAY | SettingType.FIELD_DEFINITION_ARRAY;
}

export interface JsonSetting<T = Record<string, any>> extends BaseSetting {
    Value: T;
    Type: SettingType.JSON;
}

export type Setting = StringSetting | NumberSetting | BooleanSetting | JsonSetting;
